import { PageHero } from "../components/PageHero";
import { SinovarWay } from "../components/home/SinovarWay";
import { ProofBar } from "../components/home/ProofBar";
import { Trust } from "../components/home/Trust";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";
import { ASSETS } from "../lib/site";

export default function About() {
  const { t } = useLang();
  return (
    <main data-testid="about-page">
      <PageHero kicker={t.nav.about} title={t.pages.about.title} sub={t.pages.about.sub} testId="about-hero" />
      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <p className="text-lg md:text-xl text-sinovar-navy/75 leading-relaxed">{t.pages.about.body}</p>
            <p className="mt-6 font-display text-2xl font-semibold text-sinovar-blue">{t.footer.promise}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="clip-frame overflow-hidden rounded-2xl shadow-xl aspect-[4/3]">
              <img src={ASSETS.negotiation} alt="Sinovar team" className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
      </section>
      <ProofBar />
      <SinovarWay />
      <Trust />
    </main>
  );
}
